import { ChevronRight } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('business');

const contactPointImage = getEdgeUrl('images/business/point-of-contact.png');

// TODO: confirm the real destination (scheduling link / form) for booking a
// sourcing call, and upload the account-manager image to this edge path.
const BOOK_CALL_HREF = `mailto:business@reebelo.com?subject=Book%20a%20Sourcing%20Call`;

const ContactPoint = () => (
  <section className="bg-gray-100 py-12 md:py-16">
    <div className="reebelo-container">
      <div className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm md:grid-cols-2 md:items-center">
        <div className="relative aspect-[2] h-full overflow-hidden rounded-2xl bg-gray-200 md:aspect-auto">
          <Image
            src={contactPointImage}
            alt={t`Your account manager`}
            fill
            sizes="(min-width: 768px) 50vw, 100vw"
            className="object-cover"
          />
        </div>

        <div className="mx-auto flex flex-col items-center text-center md:max-w-[500px] md:py-10">
          <span className="rounded-full bg-[#39D8921A] px-3 py-1 text-xs font-bold text-[#1F9D62]">
            {t`Your account manager`}
          </span>
          <h2 className="mt-4 text-xl font-bold text-gray-700 lg:text-2xl">
            {t`Your dedicated point of contact`}
          </h2>
          <p className="mt-3 text-sm text-gray-700/70 md:text-base">
            {t`One direct line for bulk orders, off-catalog sourcing, returns, and team growth.`}
          </p>
          <Link
            href={BOOK_CALL_HREF}
            className="mt-4 inline-flex items-center gap-3 rounded-xl bg-gray-700 px-6 py-3 text-sm font-medium text-white transition-opacity hover:opacity-90"
          >
            {t`Book a Sourcing Call`}
            <ChevronRight className="h-4 w-4 shrink-0" strokeWidth={2} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default ContactPoint;
